import { render, staticRenderFns } from "./FeedLayout.vue?vue&type=template&id=0ad92588&scoped=true"
import script from "./FeedLayout.vue?vue&type=script&lang=js"
export * from "./FeedLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad92588",
  null
  
)

export default component.exports